import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_ctx.loaiGiaTri === 'text')
    ? (_openBlock(), _createBlock(_component_el_input, {
        key: 0,
        "model-value": _ctx.modelValue,
        class: "w-full",
        placeholder: _ctx.placeholder,
        onInput: _ctx.emitValue
      }, null, 8, ["model-value", "placeholder", "onInput"]))
    : (_ctx.loaiGiaTri === 'textarea')
      ? (_openBlock(), _createBlock(_component_el_input, {
          key: 1,
          "model-value": _ctx.modelValue,
          class: "w-full",
          type: "textarea",
          rows: 3,
          placeholder: _ctx.placeholder,
          onInput: _ctx.emitValue
        }, null, 8, ["model-value", "placeholder", "onInput"]))
      : (_ctx.loaiGiaTri === 'number')
        ? (_openBlock(), _createBlock(_component_el_input, {
            key: 2,
            "model-value": _ctx.modelValue,
            class: "w-full",
            type: "number",
            placeholder: _ctx.placeholder || 'Số',
            onInput: _ctx.emitValue
          }, null, 8, ["model-value", "placeholder", "onInput"]))
        : (_ctx.loaiGiaTri === 'date')
          ? (_openBlock(), _createBlock(_component_el_date_picker, {
              key: 3,
              "model-value": _ctx.modelValue || null,
              class: "w-full",
              type: "date",
              format: "DD/MM/YYYY",
              "value-format": "YYYY-MM-DD",
              placeholder: _ctx.placeholder || 'Chọn ngày',
              "onUpdate:modelValue": _ctx.emitValue
            }, null, 8, ["model-value", "placeholder", "onUpdate:modelValue"]))
          : (_ctx.loaiGiaTri === 'boolean')
            ? (_openBlock(), _createBlock(_component_el_select, {
                key: 4,
                "model-value": _ctx.modelValue,
                class: "w-full",
                placeholder: _ctx.placeholder || 'Chọn',
                onChange: _ctx.emitValue
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "Bật (1)",
                    value: "1"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Tắt (0)",
                    value: "0"
                  })
                ]),
                _: 1
              }, 8, ["model-value", "placeholder", "onChange"]))
            : (_openBlock(), _createBlock(_component_el_select, {
                key: 5,
                "model-value": _ctx.modelValue,
                class: "w-full",
                clearable: "",
                placeholder: _ctx.placeholder || 'Chọn giá trị',
                onChange: _ctx.emitValue
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tuyChon, (opt) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: opt.value,
                      label: opt.label || opt.value,
                      value: opt.value,
                      disabled: !opt.value
                    }, null, 8, ["label", "value", "disabled"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["model-value", "placeholder", "onChange"]))
}